import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {DeleteValuationResponse} from "../payload-types/persistence-delete";

/**
 * API interface to delete a valuation in REVA (POST {@link RevaApi.PATH_VALUATIONS}/{id}/delete).
 */
export class DeleteValuationApiInterface extends SimpleApiInterface<DeleteValuationResponse> {
    constructor(private readonly revaId: string) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS, this.revaId, RevaApi.PATH_VALUATION_DELETE]);
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<DeleteValuationResponse> {
        return executor.fetchPOST(url, credentials, {});
    }
}

/**
 * API interface to delete a valuation in REVA together with its order in the Value-Orders-API
 * (POST {@link RevaApi.PATH_VALUATIONS}/{id}/deleteWithOrder).
 */
export class DeleteValuationAndOrderApiInterface extends SimpleApiInterface<DeleteValuationResponse> {
    constructor(
        private readonly revaId: string,
        private readonly reason: string,
        private readonly explanation: string,
    ) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_VALUATIONS, this.revaId, RevaApi.PATH_VALUATION_DELETE_WITH_ORDER]);
    }

    protected buildPayload(): object {
        return {reason: this.reason, explanation: this.explanation};
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<DeleteValuationResponse> {
        return executor.fetchPOST(url, credentials, this.buildPayload());
    }
}
